<script setup>
import Empty from "@/assets/empty.png";

const { putawayStatus } = defineProps(["putawayStatus"]);
</script>

<template>
  <van-overlay show z-index="4000" class-name="not-putaway-overlay">
    <div class="putaway">
      <van-image :src="Empty" class="empty-img" />
      <div class="putaway-text">
        {{ putawayStatus === 1 ? "该服务已下架" : "未找到相关资源" }}
      </div>
    </div>
  </van-overlay>
</template>

<style lang="scss" scoped>
.not-putaway-overlay {
  background: #ffffffcc;
  backdrop-filter: blur(6px);
}
.putaway {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  text-align: center;
}
.empty-img {
  width: 88px;
  height: 70px;
  margin-bottom: 8px;
}
.putaway-text {
  font-size: 12px;
  line-height: 20px;
  color: #0000004d;
}
</style>
